// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2fb7F","left":"StickyBox_left__1-rmA","right":"StickyBox_right__1d3uN"};